import { render } from "./Item1.vue?vue&type=template&id=26ec1dd7"
import script from "./Item1.vue?vue&type=script&lang=ts"
export * from "./Item1.vue?vue&type=script&lang=ts"
script.render = render

export default script